module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.resetEmailNotSent) ? _c('div', [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('p', {
    staticClass: "text-center m-b-lg"
  }, [_vm._v("If you have forgotten your password, enter your email address or mobile number below and we will send you a password reset email/sms.")]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group-email",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email/Mobile")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email/Mobile",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('ladda-button', {
    attrs: {
      "on-click": _vm.handleSendPasswordEmail,
      "type": "success",
      "button-type": "submit"
    }
  }, [_vm._v("Reset Password")])], 1)])]) : _c('div', [_c('div', {
    staticClass: "logo"
  }, [(_vm.type === 'mobile') ? _c('h1', [_vm._v("Check Your Phone")]) : _c('h1', [_vm._v("Check Your Email")])]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "swal2-show"
  }, [_c('div', {
    staticClass: "swal2-icon swal2-success swal2-animate-success-icon",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "swal2-success-circular-line-left",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-tip swal2-animate-success-line-tip"
  }), _vm._v(" "), _c('span', {
    staticClass: "swal2-success-line-long swal2-animate-success-line-long"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-ring"
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-fix",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swal2-success-circular-line-right",
    staticStyle: {
      "background": "rgb(255, 255, 255)"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.type === 'mobile') ? _c('p', {
    staticClass: "lead"
  }, [_vm._v("A message has been sent with instructions on resetting your password.")]) : _c('p', {
    staticClass: "lead"
  }, [_vm._v("An email has been sent with instructions on resetting your password.")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-7"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to Login")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'auth.register'
      }
    }
  }, [_vm._v("Register")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('h1', [_vm._v("Forgot Password?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-ab0fc4e4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/password/EmailForm.vue
// module id = 1070
// module chunks = 0